<template>
  <div>
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('settingsPages.dateTime')"></general-top-bar> -->
    <!--End General Top Bar -->
    <div :class="(loading ? 'show-loader' : 'hide-loader')">
      <div class="el-loading-spinner">
        <svg viewBox="25 25 50 50" class="circular">
          <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
        </svg><!---->
      </div>
    </div>
    <div class="settings-top-bar sticky-header" ref="optionsTopBar">
      <div class="text-right">
        <p class="d-inline-flex">
          <button type="submit" class="btn btn-success btn-icon mar-rt-10 save"  @click.prevent="validate" :title="$t('general.saveChanges')">
            <img src="/static/img/icons/save.png">
            {{$t('general.save')}}
          </button>
        </p>
      </div>
    </div>
    <form class="row mar-to-15">
      <div class="col-md-12">
        <div class="card">
          <div class="card-content">
            <p class="text-danger" v-show="errors.has('error')">
              {{ getError('error') }}
            </p>
            <div class="form-group">
              <label>{{$t('settingDateTime.timezone')}}</label>
              <div class="row">
                <el-select class="col-md-6" placeholder=" - Select Timezone - " filterable v-model="model.timezone" v-validate="[{required: true}]">
                  <el-option v-for="tz in defaults.timezones"
                              :value="tz.select_value"
                              :label="tz.display_name"
                              :key="tz.select_value"></el-option>
                </el-select>
            <!--    <small class="text-danger col-md-12" v-if="errors.has('timezone')">
                  {{ getError('timezone') }}
                </small> -->
              </div>
            </div>
            <div class="form-group">
              <label>{{$t('settingDateTime.timeFormat')}}</label>
              <div class="row">
                <el-select class="col-md-6" placeholder=" - Select Time Format - " v-model="model.time_format" v-validate="[{required: true}]">
                  <el-option v-for="(label, key) in defaults.time_formats.client"
                              :value="key"
                              :label="label"
                              :key="key"></el-option>
                </el-select>
          <!--      <small class="text-danger col-md-12" v-if="errors.has('time_format')">
                  {{ getError('time_format') }}
                </small> -->
              </div>
            </div>
            <div class="form-group">
              <label>{{$t('settingDateTime.dateFormat')}}</label>
              <div class="row">
                <el-select class="col-md-12 col-md-6" placeholder=" - Select Date Format - " v-model="model.date_format" v-validate="[{required: true}]">
                  <el-option v-for="(label, key) in defaults.date_formats.client"
                              :value="key"
                              :label="label"
                              :key="key"></el-option>
                </el-select>
    <!--             <small class="text-danger" v-if="errors.has('date_format')">
                  {{ getError('date_format') }}
                </small> -->
              </div>
            </div>
            <!-- <div class="form-group">
              <label>Interface language</label>
              <div class="row">
                <el-select class="col-md-12 col-md-12" placeholder=" - Select Language - " v-model="model.language" v-validate="modelValidate.language">
                  <el-option v-for="(label, key) in defaults.available_languages"
                              :value="key"
                              :label="label"
                              :key="key">{{label}}</el-option>
                </el-select>
                <small class="text-danger" v-if="errors.has('language')">
                  {{ getError('language') }}
                </small>
              </div>
            </div> -->
          
            <!--     <div class="col-md-12">
            <div class="form-group">
              <label>Working hours</label>
              <div class="row" v-for="day in model.working_hours">
                <div class="col-lg-3 col-md-4 col-sm-4 col-xs-12 padd">
                  <p-checkbox
                      :value="day.day"
                      :key="day.day"
                      :label="day.day"
                      v-model="day.open">{{day.day}}</p-checkbox>
                </div>
                <div class="col-lg-9 col-md-8 col-sm-8 col-xs-12 padd">
                  from 
                  <el-time-select :disabled="!day.open"
                                  placeholder="Select time"
                                  :value="day.open_from"
                                  v-model="day.open_from"
                                  v-validate="modelValidate.working_hours"
                                  :picker-options="pickerOptions">
                  </el-time-select>
                  to 
                  <el-time-select :disabled="!day.open"
                                  placeholder="Select time"
                                  :value="day.open_to"
                                  v-model="day.open_to"
                                  v-validate="modelValidate.working_hours"
                                  :picker-options="pickerOptions">
                  </el-time-select>
                </div>
              </div>
              <small class="text-danger" v-if="errors.has('working_hours')">
                {{ getError('working_hours') }}
              </small>
            </div> -->
          </div>
        </div>
      </div> 
    </form>
  </div>
</template>


<script>
  import Vue from 'vue'
  import {Input} from 'element-ui'
  import swal from 'sweetalert2'
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import 'sweetalert2/dist/sweetalert2.css'
  // import {mapFields} from 'vee-validate'
  Vue.use(Input)

  export default {
    components: {
      // GeneralTopBar,
      [Input.name]: Input
    },
    props: {
      defaultData: {},
      modeldata: {
        type: [Object, Array],
        required: true
      }
    },
    watch: {
      defaultData (value) {
        this.defaults = value
      },
      modeldata (value) {
        // console.warn(this.days)
        // console.warn(value.working_hours)
        // if (!value.working_hours) {
        //   value.working_hours = []
        // }
        // for (var iDay in this.days) {
        //   var day = this.days[iDay]
        //   var index = this.getObjectByElemKeyValue('day', day, value.working_hours)
        //   if (index === false) {
        //     value.working_hours.push({day: day, open_to: '', open_from: '', open: false})
        //   }
        // }

        this.model = value
        // console.warn(this.errors)
        this.errors.clear()
        // console.warn(this.errors)
        this.$nextTick(function () {
          // console.warn(this.errors)
        })
      }
    },
    data () {
      return {
        model: this.value || this.modeldata,
        defaults: this.value || this.defaultData, // this.countries
        modelValidate: {
          timezone: {required: true},
          time_format: {required: true},
          date_format: {required: true}
        },
        pickerNames: ['date_from', 'date_to'],
        days: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
        pickerOptions: {
          start: '00:00',
          step: '00:15',
          end: '23:59'
        },
        loading: false
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.saveDetails()
          }
        })
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors.hasOwnProperty(prop)) {
            this.errors.add(prop, errors[prop])
            // console.warn(this.errors)
          }
        }
      },
      saveDetails () {
        this.$nextTick(function () { this.loading = true })
        var companyID = this.$session.get('selectedCompany')
        var data = {
          'token': this.$session.get('token'),
          'timezone': this.model.timezone,
          'date_format': this.model.date_format,
          'time_format': this.model.time_format
          // 'language': this.model.language
          // 'working_hours': JSON.stringify(this.model.working_hours)
        }

        var self = this
        this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
          if (response.status === true) {
            self.errors.clear()
            self.$nextTick(function () { self.loading = false })
            swal({'text': self.$t('settingDateTime.saveMsg'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
          } else {
            self.$nextTick(function () { self.loading = false })
            self.handleErrors(response.errors)
            // swal({'text': 'Something went wrong, please try again later...', 'type': 'error', 'showConfirmButton': false, 'timer': 2000})
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/Tabs/DateTime.vue